package com.eladfinish.bible.contest.screens.completeVerse.ui.dialogs.numberPicker

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.how_many_words_to_hide
import com.eladfinish.bible.contest.screens.completeVerse.CompleteVerseAction
import com.eladfinish.bible.contest.ui.components.dialogs.BasicDialogWithTitle
import com.eladfinish.bible.contest.ui.components.dialogs.DialogPositiveButtonInColumn
import dev.icerock.moko.resources.compose.stringResource

@Composable
internal fun NumberPickerDialog(
    initialNumber: Int,
    onAction: (CompleteVerseAction) -> Unit,
    onNumberPicked: () -> Unit,
) {
    val close = { onAction(CompleteVerseAction.HideDialog) }
    BasicDialogWithTitle(
        onDismiss = {
            close()
        },
        title = stringResource(SharedRes.strings.how_many_words_to_hide),
        content = {
            val valuesPickerState = rememberPickerState()
            val selectedItem = valuesPickerState.selectedItem
            NumberPickerContainer(
                value = initialNumber,
                valuesPickerState = valuesPickerState,
            )
            DialogPositiveButtonInColumn(
                onClick = {
                    close()
                    onAction(CompleteVerseAction.UpdateHowManyWordsToHide(value = selectedItem.toInt()))
                    onNumberPicked()
                },
            )
            if (selectedItem.toIntOrNull() == 0) {
                Text(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(top = 10.dp),
                    text = "* בכל פסוק יושמטו מחצית מהמילים",
                    textAlign = TextAlign.Center,
                )
            }
        },
    )
}
